<template>
  <div class="doctor-entry-page employee-entry-page">
    <PageHeader icon="fas fa-user-edit">
      <template #title>Edit Karyawan</template>
      <template #subtitle>
        Perbarui identitas, akun, penempatan, dan informasi ketenagakerjaan karyawan.
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <HrForm :form="form" :route="'employees/'+ form.id" :password="false"/>
      </div>
    </div>

  </div>
</template>

<script>

import HrForm from '@/component/human-resource/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import module from '@/core/modules/CrudModule.js'

export default {

  data(){
    return {
      form:{
        email: "",
        name: "",
        birt_place: "",
        birt_date: "",
        address: "",
        phone: "",
        mobile_phone: "",
        id_card_number: "",
        employee_number_id:"",
        password: "",
        password_confirmation: "",
        position_id:"",
        depertment_id:"",
        work_start_time: "09:00",
        work_end_time: "17:00",
        employment_status: "permanent", join_date: "", end_date: "", base_salary: 0,
        bank_name: "", bank_account_number: "", bank_account_name: "", npwp: "", ptkp_status: "TK/0",
        bpjs_health_number: "", bpjs_employment_number: "", str_number: "", str_expired_at: "", sip_number: "", sip_expired_at: "",
        photo: [],
        photo_name: "/images/default-profile.svg"
      }
    }
  },

  name: 'Edit',

  components: {
    HrForm
  },

   methods: {

   async get() {
      this.form = await module.get('employees/' + this.$route.params.id)

      if (this.form == null) {
        this.$router.push('/human-resource/employee/list')
      } else {
        this.form.photo_name = this.form.photo
        this.form.photo = []
        this.form['_method'] = "PUT"
        this.dataLoaded = true
      }
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Karyawan" },
      { title: "Daftar Karyawan", route: "/human-resource/employee/list" },
      { title: "Ubah Karyawan" },
    ])
    this.get()
  },

}
</script>
